import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["quantity"];

    connect() {
        this.timeout = null;

        // Quand WooCommerce a fini de rafraîchir le panier
        jQuery(document.body).on("updated_wc_div", () => {
            jQuery(".woocommerce-cart-form, .cart_totals").unblock();
        });

        // Réactiver le bouton quand les champs de personnalisation changent
        jQuery(this.element).on("input", ".c-order-trainee input", () => {
            jQuery('[name="update_cart"]').prop("disabled", false);
        });
    }

    update(event) {
        clearTimeout(this.timeout);

        this.timeout = setTimeout(() => {

            const $form = jQuery("form.woocommerce-cart-form");

            $form.block({
                message: null,
                overlayCSS: {
                    background: "#fff",
                    opacity: 0.6
                }
            });

            const $updateButton = $form.find('[name="update_cart"]')
            $updateButton.prop("disabled", false);
            $updateButton.trigger("click");
        }, 500);
    }
}
